import { useNavigate } from "react-router-dom";
import { ProfileManager } from "../ProfileManager.js";
import info from "../../info.json"

export default function Header() {
  let navigate = useNavigate();
  let env = info.env;
  return <div className="flex flex-col mb-4">
    <div className="flex flex-row justify-between w-full">
      <div className="h-[2rem] aspect-logo">
        <img className="cursor-pointer" src="/img/logo.png" onClick={() => navigate("/home")} />
      </div>
      <div className="h-[1.75] text-[1.75rem] tracking-wide font-bold leading-none text-toda-gray">
        {env!= "PROD" ? `Back-office (${env})` : "Back-office"} 
      </div>
      <ProfileManager />
    </div>
  </div>;
}
